import { Box, Button, ButtonGroup, FormHelperText } from '@mui/material'
import { Apps, ViewComfy } from '@mui/icons-material'

function DetailIDSwitch({
  detailOn,
  setDetailOn,
}: {
  detailOn: boolean
  setDetailOn: any
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        width: '120px',
      }}
    >
      <ButtonGroup
        color="primary"
        sx={{ width: 1 }}
      >
        <Button
          disabled={!detailOn}
          onClick={() => setDetailOn(false)}
          sx={{ width: 1 }}
          aria-label={'compact-view'}
        >
          <Apps />
        </Button>
        <Button
          disabled={detailOn}
          onClick={() => setDetailOn(true)}
          sx={{ width: 1 }}
          aria-label={'comfy-view'}
        >
          <ViewComfy />
        </Button>
      </ButtonGroup>
      <FormHelperText sx={{ textAlign: 'center' }}>
        {detailOn ? 'Detail View' : 'ID View'}
      </FormHelperText>
    </Box>
  )
}

export default DetailIDSwitch
